import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';

const ContactUs = () => {
  return (
    <div className={styles['contact-us-page']}>
      <div className={styles.page}>
        <section className={styles['contact-hero']} aria-label="Contact">
          <div className={styles['contact-hero__overlay']}>
            <SiteTopNav />
            <div className={styles['contact-hero__content']}>
              <h1 className={styles['contact-hero__title']} data-motion="hero">
                Serve You Better
              </h1>
            </div>
          </div>
        </section>

        <section
          className={styles['contact-intro']}
          aria-labelledby="contact-intro-heading"
          data-motion="section"
        >
          <h2
            id="contact-intro-heading"
            className={styles['contact-intro__title']}
            data-motion="title"
          >
            Get in Touch
          </h2>
          <div className={styles['contact-intro__details']} data-motion="copy">
            <p className={styles['contact-intro__line']}>
              Address: PO Box 241, Brentwood, CA 94513
            </p>
            <p className={styles['contact-intro__line']}>
              Email:{' '}
              <a className={styles['contact-intro__link']} href="mailto:info@sakurafloors.com">
                info@sakurafloors.com
              </a>
            </p>
          </div>
        </section>

        <section
          className={styles['contact-form-embed']}
          aria-label="Contact form"
          data-motion="card"
        >
          <div className={styles['contact-form-embed__frame-wrap']}>
            <iframe
              className={styles['contact-form-embed__iframe']}
              title="Sakura Floors contact form"
              allowFullScreen
              allow="geolocation; microphone; camera"
              src="https://83jxmr78.forms.app/form/69c95d091b427410eff3eb16"
            />
            {/* Masks embedded branding (cross-origin: parent CSS cannot hide `.powered.generic-branding`). */}
            <div className={styles['contact-form-embed__branding-mask']} aria-hidden="true" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactUs;
